import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import LinesAdd from './../../elements/lines/widget/lines_add';
import LinesSearch from './../../elements/lines/widget/lines_search';

class ProigualdadLines extends Component {
	render() {
		return (
			<LinesList {...this.props} />
		)
	}

	componentWillMount() {
		this.props.linesShow(this.props.lines.pages.current);
	}
}

export class LinesList extends Component {
	render() {
		let { lines } = this.props;

		let lu = _.find(lines.permissions, (o) => {return o==='Update'});
		let ld = _.find(lines.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{lines.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Código</th>
							<th>Nombre</th>
						</tr>
						</thead>
						<tbody>
						{_.map(lines.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:'80px'}}>
										<div className="actions">
											{lu ? <NavLink to={`/proigualdad/lineas/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{ld ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.code}</td>
									<td><strong>{row.name}</strong></td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{lines.pages.total>20 &&
				<InmPagination key="lines-pages"
				               current={lines.pages.current}
				               total={lines.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		const { lines } = this.props;
		this.props.linesShow(value, lines.filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la linea "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.lineDelete(id)
		})
	}
}

export default BaseLayout(ProigualdadLines, {
	title:"Lineas Proigualdad",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <LinesSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <LinesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/lines/index.jsx